import sentGAEvent from ".";

/**
 * 购买页面展示
 */
const GAPurchasePageDisplay = () => {
  sentGAEvent({
    category: "pricing",
    action: "pricing_display",
  });
};

/**
 * 月套餐点击购买
 */
const GAPurchaseMonthlyClick = () => {
  sentGAEvent({
    category: "pricing",
    action: "pricing_month_click",
  });
};

/**
 * 年套餐点击购买
 */
const GAPurchaseYearlyClick = () => {
  sentGAEvent({
    category: "pricing",
    action: "pricing_year_click",
  });
};

/**
 * 购买弹窗去购买
 */
const GAPurchaseModalBuyClick = () => {
  sentGAEvent({
    category: "premium_popup",
    action: "premium_popup_buy",
  });
};

export { GAPurchasePageDisplay, GAPurchaseMonthlyClick, GAPurchaseYearlyClick, GAPurchaseModalBuyClick };
